(contextArray => {
  // Automatically import all of the icons
  contextArray.forEach(context => {
    context.keys().forEach(context);
  });
})(
  [
    require.context('src/images/icons/', false, /\.svg$/),
    require.context('src/images/icons-raw/', false, /\.svg$/)
  ]
);
